"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isResponseError = isResponseError;
exports["default"] = exports.HTTPVerb = exports.RequestResolve = exports.ActionStates = void 0;

var _superagent = _interopRequireDefault(require("superagent"));

var _has2 = _interopRequireDefault(require("lodash/has"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * When defining actions that could interact with the DataService
 * middleware these are the suffixes that will be attached to
 * actions that are emitted upon success or failure. Your stores
 * should respond appropriately or provide action creators which
 * dispatch the appropriate suffixed action.
 */
var ActionStates = {
  SUCCESS: '_SUCCESS',
  ERROR: '_ERROR'
};
/**
 * Determines how to handle requests to the same resource or
 * identifier.
 *
 * IGNORE skips the action if a request is already in progress.
 *
 * CANCEL aborts the previous request in favor of the new one.
 */

exports.ActionStates = ActionStates;
var RequestResolve = {
  IGNORE: 0,
  CANCEL: 1
};
exports.RequestResolve = RequestResolve;
var HTTPVerb = {
  GET: 'get',
  POST: 'post',
  DELETE: 'delete',
  PUT: 'put'
};
/**
 * determines whether an error is a superagent "soft" error generated as a result from a network
 * response.
 *
 * > Note that superagent considers 4xx and 5xx responses (as well as unhandled 3xx responses)
 * > errors by default. For example, if you get a 304 Not modified, 403 Forbidden or 500 Internal
 * > server error response, this status information will be available via err.status. Errors from
 * > such responses also contain an err.response field with all of the properties mentioned in
 * > "Response properties"
 *
 * https://visionmedia.github.io/superagent/#error-handling
 */

exports.HTTPVerb = HTTPVerb;

function isResponseError(error) {
  if (error.crossDomain) return true;
  if (error.response === undefined) return false;
  if (error.status === undefined) return false;
  return true;
}

var DataService = /*#__PURE__*/function () {
  function DataService(actionHandlers, unauthorizedHandler) {
    var _this = this;

    _classCallCheck(this, DataService);

    _defineProperty(this, "middleware", function (store) {
      return function (next) {
        return function (action) {
          // Pass the current action along
          var result = next(action);
          var handler = _this.actionHandlers[action.type];
          if (!handler) return result; // Make async call; returns a promise so components can `await`/`.then` it.

          return _this.makeHTTPRequest(next, handler, action, store.getState());
        };
      };
    });

    /**
     * By default IGNORE subsequent requests to the same
     * URL or action.identifier.
     */
    this.defaultRequestResolve = RequestResolve.IGNORE;
    /**
     * An object keyed on Redux action strings
     * with objects for values in the shape of
     *
     * {
     *   httpMethod: HTTPVerb,
     *   route: string
     * }
     */

    this.actionHandlers = actionHandlers;
    /**
     * Callback that will have the opportunity to handle
     * a response which results in a 401 statusCode.
     */

    this.unauthorizedHandler = unauthorizedHandler;
    /**
     * Holds a cache of superagent requests and
     * should be keyed on an action.identifier or
     * the URL of the request.
     */

    this.requestCache = {};
  } // ======================================================
  // redux Middleware
  // ======================================================

  /**
   * DataService middleware (http://redux.js.org/docs/advanced/Middleware.html)
   *
   * Watches for specific actions typically in the format of
   *
   * <ACTION (FETCH, UPDATE, etc)>_<RESOURCE>, FETCH_SURVEY...
   *
   * and dispatches network requests as needed. Network requests
   * will dispatch either a _RECEIVED (success) or _ERROR (failure)
   * action upon completion.
   *
   * This middleware is designed to tie the API (which will become its own soon)
   * to the Application, not tie the application to the middleware, the application
   * should be unaware of this middlewares effects and where it
   * receives its data from.
   *
   * A goal is to provide this class with an API implementation which can easily
   * be swapped out with a stub implementation that just fetches from local
   * data.
   *
   * This service was built off of this article
   * http://www.sohamkamani.com/blog/2016/06/05/redux-apis/
   *
   */


  _createClass(DataService, [{
    key: "responseHandler",

    /**
     * Standard Response Handler
     *
     * Used as a catch all to handle global errors such as
     * 401 Unauthorized.
     */
    value: function responseHandler(next, action, authentication, res, req, err) {
      if (err && err.status === 401) {
        if (this.unauthorizedHandler(next, action, authentication)) {
          return;
        }
      }

      var data = Array.isArray(res.body) ? {
        results: res.body
      } : res.body;
      var network = {
        headers: res.headers
      };
      next({
        type: action.type + (err ? ActionStates.ERROR : ActionStates.SUCCESS),
        identifier: action.identifier,
        payload: {
          data: data || {},
          error: err ? 'Error' : null
        },
        network: network,
        originalPayload: action.payload
      });
      var identifier = this.getCacheKey(action, req.url);
      delete this.requestCache[identifier];
    }
    /**
     * Assembles an HTTP request from a handler.
     *
     * @param {Object} handler
     * @param {Object} action
     * @param {Object} authentication see @src/redux/reducers/authentication
     * @returns {Promise} result
     */

  }, {
    key: "makeHTTPRequest",
    value: function () {
      var _makeHTTPRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(next, handler, action, state) {
        var app, authentication, route, path, req, cacheKey, activeRequest, requestResolve, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.isStateValid(state);
                app = state.app;
                authentication = state.authentication;
                route = this.getRouteFromHandler(handler, action, authentication);
                path = this.buildPath(authentication, route);
                req = _superagent["default"][handler.httpMethod](path).set('Authorization', 'Bearer ' + authentication.api.token).set('X-Sift-App', "".concat(app.name, "/").concat(app.version, " ").concat(app.platform)).set('Accept', 'application/json');

                if (handler.upload) {
                  req.field(handler.upload, action.payload.data);
                } else {
                  req.query(action.payload.query);
                } // Cache


                cacheKey = this.getCacheKey(action, req.url);
                activeRequest = this.requestCache[cacheKey];
                requestResolve = action.payload.requestResolve || this.defaultRequestResolve;

                if (!activeRequest) {
                  _context.next = 17;
                  break;
                }

                if (!(requestResolve === RequestResolve.CANCEL)) {
                  _context.next = 15;
                  break;
                }

                activeRequest.abort();
                _context.next = 17;
                break;

              case 15:
                if (!(requestResolve === RequestResolve.IGNORE)) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt("return", Promise.resolve(null));

              case 17:
                this.requestCache[cacheKey] = req; // Pass handler prop to action from the DataServiceActionHandlers.js page for conditional 401 responses

                action.dataServiceHandler = handler; // Send

                if (!handler.upload) {
                  req.send(action.payload.data);
                }

                _context.prev = 20;
                _context.next = 23;
                return req;

              case 23:
                res = _context.sent;
                this.responseHandler(next, action, authentication, res, req, undefined);
                return _context.abrupt("return", res);

              case 28:
                _context.prev = 28;
                _context.t0 = _context["catch"](20);

                if (!(_context.t0.code === 'ABORTED')) {
                  _context.next = 32;
                  break;
                }

                return _context.abrupt("return");

              case 32:
                if (isResponseError(_context.t0)) {
                  _context.next = 34;
                  break;
                }

                throw _context.t0;

              case 34:
                this.responseHandler(next, action, authentication, _context.t0.response || {}, req, _context.t0);

              case 35:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[20, 28]]);
      }));

      function makeHTTPRequest(_x, _x2, _x3, _x4) {
        return _makeHTTPRequest.apply(this, arguments);
      }

      return makeHTTPRequest;
    }() // ======================================================
    // Utils
    // ======================================================

  }, {
    key: "buildPath",
    value: function buildPath(authentication, route) {
      return authentication.api.path + '/api/' + route;
    }
  }, {
    key: "getCacheKey",
    value: function getCacheKey(action, path) {
      var key = path.split('?')[0];

      if (action.identifier) {
        key = "".concat(action.identifier, "-").concat(key);
      }

      return key;
    }
  }, {
    key: "getRouteFromHandler",
    value: function getRouteFromHandler(handler, action, authentication) {
      return typeof handler.route === 'function' ? handler.route(authentication, action) : handler.route;
    }
  }, {
    key: "isStateValid",
    value: function isStateValid(state) {
      var isValid = true;
      ['authentication.api.token', 'authentication.api.path', 'app.name', 'app.version', 'app.platform'].forEach(function (path) {
        if (!(0, _has2["default"])(state, path)) {
          throw new Error("".concat(path, " does not exist on state."));
        }
      });
      return isValid;
    }
  }]);

  return DataService;
}();

var _default = DataService;
exports["default"] = _default;